import { BookingProposalItemRecord, BookingProposalItemRecordList } from '@navio/nsdk';
import { NoddiDateFormats, noddiFormatDate } from 'noddi-util';

type ProposalItem = BookingProposalItemRecord | BookingProposalItemRecordList;

type ProposalItemsByCar<T extends ProposalItem> = {
  car: T['car'];
  items: T[];
};

export const groupBookingProposalItemsByCar = <T extends ProposalItem>(items: T[]): ProposalItemsByCar<T>[] => {
  const groups = new Map<number, ProposalItemsByCar<T>>();
  items.forEach((item) => {
    const existing = groups.get(item.car.id);
    if (existing) {
      existing.items.push(item);
    } else {
      groups.set(item.car.id, { car: item.car, items: [item] });
    }
  });
  return Array.from(groups.values());
};

export const getProposalDateLabel = ({
  timeSlotStartsAt,
  dateSuggested
}: {
  timeSlotStartsAt?: string | null;
  dateSuggested?: string | null;
}) => {
  if (timeSlotStartsAt) {
    return noddiFormatDate(timeSlotStartsAt, NoddiDateFormats.DATE_TIME);
  }
  if (dateSuggested) {
    return noddiFormatDate(dateSuggested, NoddiDateFormats.DATE);
  }
  return null;
};
